import React from 'react';

const CustomLoader1 = ({ text = 'Loading' }) => {
    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                width: '100vw',
                textAlign: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.8)',
            }}
        >

            {/* Loading Text with Animated Dots */}
            <span
                style={{
                    fontSize: '16px',
                    color: '#363636',
                    fontWeight: '600',
                    display: 'flex',
                    gap: '5px',
                    alignItems: 'center',
                }}
            >
                {/* {text} */}
                <span
                    style={{
                        display: 'flex',
                        gap: '4px',
                    }}
                >
                    <span style={{ height: "10px", width: "10px", borderRadius: "50%", animation: 'bounce 1s infinite 0s', background: '#225B88' }}></span>
                    <span style={{ height: "10px", width: "10px", borderRadius: "50%", animation: 'bounce 1s infinite 0.2s', background: '#2E73A7' }}></span>
                    <span style={{ height: "10px", width: "10px", borderRadius: "50%", animation: 'bounce 1s infinite 0.4s', background: '#3A8DC2' }}></span>
                 
                </span>
            </span>

            {/* Inline Keyframe Animations */}
            <style>
                {`
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
          @keyframes bounce {
            0%, 100% {
              transform: translateY(0);
            }
            50% {
              transform: translateY(-8px);
            }
          }
        `}
            </style>
        </div>
    );
};

export default CustomLoader1;
